<div class="itinerary-detail-container">
  <app-itinerary-loading *ngIf="isLoading"></app-itinerary-loading>
  <ng-container *ngIf="!isLoading">
    <div class="itinerary-detail-header">
      <span>{{'BOOKING_MODULE.YOUR_ITINERARY' | transloco}}</span>
    </div>
    <div class="itinerary-detail-body">
      <ng-container *ngIf="isBus; else flightSector">
        <app-bus-sectors
          [busClass]="flightClass"
          [isMobile]="isMobile"
          [provider]="provider"
          [airValidationSector]="airValidationSector | airValidationSectorVm"
          [travelType]="travelType"
          [sectorSelected]="sectorSelected"
          [passengerArrangement]="passengerArrangement"
          [price]="price"
          [conversionRate]="conversionRate"
          [productReference]="productReference">
        </app-bus-sectors>
      </ng-container>
      <ng-template #flightSector>
        <app-flight-sectors
          [flightClass]="flightClass"
          [isMobile]="isMobile"
          [provider]="provider"
          [airValidationSector]="airValidationSector | airValidationSectorVm"
          [travelType]="travelType"
          [sectorSelected]="sectorSelected"
          [isLoadingFlightCabin]="isLoadingFlightCabin"
          [passengerArrangement]="passengerArrangement"
          [price]="price"
          [conversionRate]="conversionRate"
          [isInternational]="isInternational"
          [productReference]="productReference">
        </app-flight-sectors>
      </ng-template>
    </div>
  </ng-container>
</div>
